import React from "react";
import { Tooltip, TooltipProps } from "@mui/material";

const ControlledTooltip = (props: TooltipProps) => {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => setOpen(false);

  const handleOpen = (event: React.SyntheticEvent) => {
    const elem = event.target as HTMLElement;
    if (elem.scrollWidth > elem.offsetWidth) {
      setOpen(true);
    }
  };

  const renderChildren = () => {
    return React.cloneElement(props.children, {
      onMouseEnter: handleOpen,
      onMouseLeave: handleClose,
    });
  };

  return (   
    <Tooltip disableHoverListener open={open} followCursor {...props}>
      {renderChildren()}
    </Tooltip>
  );
}

export default ControlledTooltip;